import { match } from '@st/pattern'
import { selectPaymentFields } from './model'
import type { ChecklistMessage } from '~/features/checklists/module'
import { ChecklistEditDialog, ChecklistNote } from '~/features/checklists/edit-dialog'
import { TaxPaymentFields } from '~/features/checklists/delivery/fields'
import type { ChecklistEditor } from '~/features/checklists/model'

export function TaxPaymentDialog({
  editor,
  onClose,
  send
}: {
  editor: Extract<ChecklistEditor, { kind: 'tax_payment' }>
  send: (message: ChecklistMessage) => void
  onClose: () => void
}) {
  const { target, draft, catalog } = editor
  const context = draft.context
  const model = selectPaymentFields(context, catalog)
  return (
    <ChecklistEditDialog
      subtitle="Tax payment"
      editing={target.mode == 'edit'}
      valid={model.valid}
      onClose={onClose}
      onSave={() => send({ type: 'saveChecklistDialog' })}
    >
      <TaxPaymentFields
        model={model}
        send={(message) => send({ type: 'taxPaymentChanged', message })}
        dueOn={draft.dueOn ?? ''}
        setDueOn={(dueOn) => send({ type: 'checklistDraftChanged', patch: { dueOn } })}
      />
      {match(editor.instructions)
        .with({ status: 'loading' }, () => (
          <p className="text-sm text-gray-500">Loading payment instructions…</p>
        ))
        .with({ status: 'failed' }, () => (
          <p className="text-sm text-amber-800">
            Payment instructions could not be loaded. You can enter a note manually.
          </p>
        ))
        .with(undefined, () => null)
        .exhaustive()}
      <div className="space-y-2">
        <ChecklistNote
          value={draft.note}
          onChange={(note) => send({ type: 'checklistDraftChanged', patch: { note } })}
        />
        {draft.note.includes('/payment-instructions/') && (
          <p className="text-sm text-gray-500">
            Auto-generated payment instructions are in beta. Please review them and send suggestions
            to{' '}
            <a href="mailto:support@stanfordtax.com" className="underline">
              support@stanfordtax.com
            </a>
            .
          </p>
        )}
      </div>
    </ChecklistEditDialog>
  )
}
